import { useCurrentQuiz } from "./current-quiz.hook";

/**
 * Custom hook to determine if a user can view reports for a given quiz.
 *
 * @param editionId The ID of the edition to check.
 * @returns A boolean indicating if the user can view results for the quiz.
 */
export const useCanViewResults = (editionId: string) => {
  const { data: currentQuiz } = useCurrentQuiz(editionId);

  return (
    Boolean(currentQuiz?.status === "DELIVERED" && currentQuiz?.result) ||
    (currentQuiz?.appealReviewCount || 0) > 0
  );
};
